import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
// import CherryPopup from "../../components/CherryPopup";
import {
  LevelContainer,
  TilesContainer,
  InnerTilesContainer,
} from "./LevelOne.styled";
import Tile from "../../components/Tile";
import tileSVG from "../../assets/images/LevelOne/tile.svg";
import Navbar from "../../components/common/Navbar";
import LevelComplete from "../../components/common/LevelComplete/LevelComplete";

export default function LevelOne(props) {
  const [isComplete, setComplete] = useState(false);
  let history = useHistory();
  const nextLevel = () => {
    // props.toggleHint(false);
    // props.transition.volume = 0.6;
    // props.transition.play();
    history.push("/2");
  };
  // eslint-disable-next-line
  const [position, setPosition] = useState({
    first: {
      x: "0%",
      y: "0%",
      position: "first",
    },
    second: {
      x: "100%",
      y: "0%",
      position: "second",
    },
    third: {
      x: "0%",
      y: "100%",
      position: "third",
    },
    fourth: {
      x: "100%",
      y: "100%",
      position: "fourth",
    },
  });
  const [won, setWon] = useState(false);
  const [move, setMove] = useState(false);

  const [TileOne, setTileOne] = useState(position.first);
  const [TileTwo, setTileTwo] = useState(position.second);
  const [TileThree, setTileThree] = useState(position.third);
  const [EmptyTile, setEmptyTile] = useState(position.fourth);

  const [BgTileOne, setBgTileOne] = useState(position.first);
  const [BgTileTwo, setBgTileTwo] = useState(position.third);
  const [BgTileThree, setBgTileThree] = useState(position.fourth);
  const [BgEmptyTile, setBgEmptyTile] = useState(position.second);

  // Call won state
  useEffect(() => {
    setTimeout(() => {
      if (won) {
        setMove(true);
      }
    }, 500);
  }, [won]);
  // useEffect(() => {
  //   setTimeout(() => {
  //     props.toggleHint(true);
  //   }, 10000);
  //   props.changeLevelName("Swaportunity");
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    setTimeout(() => {
      checkWinStatus();
    }, 100);
    // eslint-disable-next-line
  }, [TileOne, TileTwo, TileThree, BgTileOne, BgTileTwo, BgTileThree]);

  const changePosition = (num) => {
    // props.click.volume = 0.3;
    // props.click.currentPosition = 0;
    // props.click.play();
    switch (num) {
      case "1":
        moveTileOne();
        break;
      case "2":
        moveTileTwo();
        break;
      case "3":
        moveTileThree();
        break;
      case "4":
        moveBgTileOne();
        break;
      case "5":
        moveBgTileTwo();
        break;
      case "6":
        moveBgTileThree();
        break;
      default:
        break;
    }
  };

  const checkWinStatus = () => {
    if (
      TileOne.position === "third" &&
      TileTwo.position === "first" &&
      TileThree.position === "second" &&
      BgTileOne.position === "fourth"
    ) {
      // props.clear.volume = 0.6;
      // props.clear.play();
      setComplete(true);
      setWon(true);
    }
  };
  const findPosition = (axis) => {
    // eslint-disable-next-line
    return Object.keys(position).find((current) => {
      if (position[current].x === axis.x && position[current].y === axis.y) {
        return current;
      }
    });
  };

  const Movable = (currentPosition, emptyPosition) => {
    switch (currentPosition) {
      case "first":
        if (emptyPosition !== "fourth") {
          return true;
        } else {
          return false;
        }

      case "second":
        if (emptyPosition !== "third") {
          return true;
        } else {
          return false;
        }

      case "third":
        if (emptyPosition !== "second") {
          return true;
        } else {
          return false;
        }

      case "fourth":
        if (emptyPosition !== "first") {
          return true;
        } else {
          return false;
        }

      default:
        break;
    }
  };

  const moveTileOne = () => {
    let currentPosition = findPosition(TileOne);
    let emptyPosition = findPosition(EmptyTile);
    if (Movable(currentPosition, emptyPosition)) {
      setTileOne(EmptyTile);
      setEmptyTile(position[currentPosition]);
    }
  };
  const moveTileTwo = () => {
    let currentPosition = findPosition(TileTwo);
    let emptyPosition = findPosition(EmptyTile);
    if (Movable(currentPosition, emptyPosition)) {
      setTileTwo(EmptyTile);
      setEmptyTile(position[currentPosition]);
    }
  };
  const moveTileThree = () => {
    let currentPosition = findPosition(TileThree);
    let emptyPosition = findPosition(EmptyTile);
    if (Movable(currentPosition, emptyPosition)) {
      setTileThree(EmptyTile);
      setEmptyTile(position[currentPosition]);
    }
  };
  const moveBgTileOne = () => {
    let currentPosition = findPosition(BgTileOne);
    let emptyPosition = findPosition(BgEmptyTile);
    if (Movable(currentPosition, emptyPosition)) {
      setBgTileOne(BgEmptyTile);
      setBgEmptyTile(position[currentPosition]);
    }
  };
  const moveBgTileTwo = () => {
    let currentPosition = findPosition(BgTileTwo);
    let emptyPosition = findPosition(BgEmptyTile);
    if (Movable(currentPosition, emptyPosition)) {
      setBgTileTwo(BgEmptyTile);
      setBgEmptyTile(position[currentPosition]);
    }
  };
  const moveBgTileThree = () => {
    let currentPosition = findPosition(BgTileThree);
    let emptyPosition = findPosition(BgEmptyTile);
    if (Movable(currentPosition, emptyPosition)) {
      setBgTileThree(BgEmptyTile);
      setBgEmptyTile(position[currentPosition]);
    }
  };
  return [
    move && <LevelComplete levelNum={1} />,
    <Navbar won={won} levelNum={1} />,
    <LevelContainer show={true}>
      <TilesContainer>
        <InnerTilesContainer>
          <Tile
            position={TileOne}
            number="1"
            changePosition={(num) => changePosition(num)}
            image={tileSVG}
            rotate="270deg"
          />
          <Tile
            position={TileTwo}
            number="2"
            changePosition={(num) => changePosition(num)}
            image={tileSVG}
            rotate="0deg"
          />
          <Tile
            position={TileThree}
            number="3"
            changePosition={(num) => changePosition(num)}
            image={tileSVG}
            rotate="90deg"
          />
          <Tile
            position={BgTileOne}
            number="4"
            changePosition={(num) => changePosition(num)}
            image={tileSVG}
            rotate="180deg"
            bg
          />
          <Tile
            position={BgTileTwo}
            number="5"
            changePosition={(num) => changePosition(num)}
            bg
          />
          <Tile
            position={BgTileThree}
            number="6"
            changePosition={(num) => changePosition(num)}
            bg
          />
        </InnerTilesContainer>
      </TilesContainer>
    </LevelContainer>,
    // ,
    // <CherryPopup
    //   isComplete={isComplete}
    //   nextLevel={nextLevel}
    //   mode={props.mode}
    //   levelName="Drumstep"
    // />,
  ];
}
